
/**
 * 判断是否是百福德三方环境
 */
export function BFD_checkOtherApp() {
  if (window.navigator.userAgent.indexOf('ekp-i-kk5') > -1 || window.navigator.userAgent.indexOf('ekp-i-android-kk5') > -1) {
    // 建科
    return true
  } else {
    return false
  }
}

export function initOtherSDK() {
  const type = BFD_checkOtherApp()
  if (type) {
    loadFUNJS()
  }
}

/**
 * 加载js依赖文件
 */
export function loadFUNJS() {
  let domain = 'static.dongfangfuli.com'
  if (window.location.origin.indexOf('m-test05') > -1 || window.location.origin.indexOf('m.test05')) {
    domain = "static-test05.dongfangfuli.com"
  } else if (window.location.origin.indexOf('m-stage') > -1 || window.location.origin.indexOf('m.stage')) {
    domain = "static-stage.dongfangfuli.com"
  }
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = `https://${domain}/info/mallh5/kk-1.3.19.min.js`;
  document.head.appendChild(script);
  console.log('loadFUNJS11')
}
export function BFD_appOpenOtherScan(callBack) {
  const _win = window
  try {
    //步骤4: 监听ready事件，回调后即可使用kk的API
    //应用运行入口:
    _win.kk.ready(function () {
      //扫描二维码
      _win.kk.scaner.scanTDCode(function (res) {
        if (res && res.code) {
          callBack && callBack(res.code)
        } else {
          callBack && callBack(null)
        }
      });
    });
  } catch (e) {
    callBack && callBack(null)
    console.log('App扫描失败', e)
    return {};
  }
}
